import { createFeatureSelector, createSelector } from '@ngrx/store';
import { addUserFeatureKey, AddUserState } from './add-user.reducer';

const getAddUserFeature = createFeatureSelector<AddUserState>(addUserFeatureKey);

export const getAddUserCallState = createSelector(getAddUserFeature, (state) => {
   return state.callState;
});
